import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { FeatureId } from 'shared/models/productSubscription'

import { FleetApplication } from '../models'
import { OnboardingChecklist } from '../models/onboarding'
import { parsePlaidAccount } from '../models/plaid'
import { parseTrailer } from '../models/trailer'
import { parseTruck } from '../models/truck'

interface OnboardingChecklistResult {
  applicationChecklist?: ReadonlyArray<OnboardingChecklist>
  roadPreparationChecklist?: ReadonlyArray<OnboardingChecklist>
  flexChecklist?: ReadonlyArray<OnboardingChecklist>
  cashChecklist?: ReadonlyArray<OnboardingChecklist>
}

export function fetchUserOnboardingChecklist(
  userId: string,
  featureId?: FeatureId
): Promise<OnboardingChecklistResult | undefined> {
  const url = `/api/v1/users/${userId}/checklist/${featureId ? `?feature_id=${featureId}` : ''}`

  return axios.get(url).then((response) => {
    if (response.status === HttpStatus.OK) {
      return {
        ...(response.data.flex_checklist && {
          flexChecklist: parseApplicationChecklist(response.data.flex_checklist),
        }),
        ...(response.data.cash_checklist && {
          cashChecklist: parseApplicationChecklist(response.data.cash_checklist),
        }),
        ...(response.data.application_checklist && {
          applicationChecklist: parseApplicationChecklist(response.data.application_checklist),
        }),
        ...(response.data.road_prep_checklist && {
          roadPreparationChecklist: parseApplicationChecklist(response.data.road_prep_checklist),
        }),
      }
    }
  })
}

function parseApplicationChecklist(
  checklist: ReadonlyArray<Omit<OnboardingChecklist, 'statusDetail'> & { status_detail: string }>
): ReadonlyArray<OnboardingChecklist> {
  return checklist.map((c: any) => ({
    ...c,
    statusDetail: c.status_detail,
    context: parseContext(c.context),
    subitems: c.subitems.map((s: any) => ({
      ...s,
      context: parseContext(s.context),
    })),
  }))
}

function parseContext(context: any) {
  return {
    ...context,
    ...(context?.fleet_application
      ? { fleetApplication: parseFleetApplication(context.fleet_application) }
      : undefined),
    ...(context?.truck ? { truck: parseTruck(context.truck) } : undefined),
    ...(context?.trailer ? { trailer: parseTrailer(context.trailer) } : undefined),
    ...(context?.plaid_account ? { plaidAccount: parsePlaidAccount(context.plaid_account) } : undefined),
  }
}

function parseFleetApplication(fleetApplication: any): FleetApplication {
  return {
    businessType: fleetApplication.business_type,
    businessDocumentation: fleetApplication.business_documentation,
    certificateOfInsurance: fleetApplication.certificate_of_insurance,
    operatingAuthorityLetter: fleetApplication.operating_authority_letter,
  }
}
